module.exports = __webpack_public_path__ + "img/kh25.8aed841a.png";